import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import { setOrderConfirmationModal} from '../actions/modalActions'
import PropTypes from 'prop-types'
import * as types from '../../constants/Types'
import * as resource from '../../constants/Resources'
import { getTranslation, getObjectItem } from '../../actions/dataActions'

class OrderConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.setOrderConfirmationModal(false, '', []);       
    }

    render() {
        let additionalprice = 0;
        const lines = [];
        if (this.props.orderConfirmationModal.receiptlines) {
          this.props.orderConfirmationModal.receiptlines.map(rec => {
            lines.push(rec);
            if (rec.linetype !== types.SUBTOTAL_LINE) {
              additionalprice += rec.price;
            }
            rec.discount.map(d => {
              additionalprice += d.Price;
              return '';
            })
            return additionalprice;
          })
        }

        const objectItemNumber = this.props.orderConfirmationModal.objectitemnumber;
        let receiptLines = [];
        if(this.props.orderConfirmationModal.receiptlines !== undefined) {
            receiptLines = this.props.orderConfirmationModal.receiptlines;
        }

        return (
            <Modal className='orderConfirmationModal'                
                contentLabel=""
                isOpen={this.props.orderConfirmationModal.show}
                style={properties.orderConfirmationModalStyle}
            >
                <div className="orderConfirmationModal_header">
                    <div className="header_top">
                        {this.props.getTranslation(resource.ORDER_OVERVIEW)}
                    </div>
                </div>

                <div className="orderConfirmationModal_content">
                <div className="receiptline-headerwrapper">

                    <div className="header-amount">
                        {this.props.getTranslation(resource.QUANTITY)}
                    </div>
                    <div className="header-description">
                        {this.props.getTranslation(resource.DESCRIPTION)}
                    </div> 
                    <div className="header-price">
                        {this.props.getTranslation(resource.PRICE)}
                    </div>
                </div>

                    <div className="receiptline-wrapper">                                   
                 {
                       receiptLines.map(line => {
                            return (
                                <div key={line.id} className="receiptline">
                                    <div className="receiptline-amount">
                                        {line.quantity}
                                    </div>
                                    <div className="receiptline-description">
                                        {line.text}
                                    </div>
                                    <div className="receiptline-price">
                                        {line.price.toFixed(2).replace('.', ',')}
                                    </div> 
                                </div>    
                            )
                        })
                    }
                    </div>
                    <div className="totalamount-wrapper">
                    {this.props.getTranslation(resource.SUB_TOTAL)}: {additionalprice.toFixed(2).replace('.', ',')} 
                    </div>
                </div>
                <div className="orderConfirmationModal_footer">
                    <div className="footer-text">
                        <div className="footer-text-top">
                            #{objectItemNumber}
                        </div>
                        <div className="footer-text-bottom">
                            {this.props.getTranslation(resource.ORDER_BEING_PREPARED)}
                        </div>
                    </div>
                    <div className="footer-button">
                    <button className="btn-ok" onClick={this.closeModal} >
                        {this.props.getTranslation(resource.STATUS_OK)}
                        <Ink />
                    </button> 
                    </div>
                </div>
            </Modal>
        )
    }
}

OrderConfirmationModal.propTypes = {
    setOrderConfirmationModal: PropTypes.func,
    getTranslation: PropTypes.func,
    getObjectItem: PropTypes.func
}

function mapStateToProps(state) {
    return {
        orderConfirmationModal: state.modalState.orderConfirmationModal,
    }
}

export default connect(mapStateToProps, {
    setOrderConfirmationModal,
    getTranslation,
    getObjectItem
})(OrderConfirmationModal)


// WEBPACK FOOTER //
// src/modal/components/OrderConfirmationModal.jsx